/**
 * The signed-in navigation (PRD 16): five items per role in the bottom bar (a side rail on
 * tablets), and for officers the console section in the side navigation at 1024 px and up.
 * Paths are the route map in docs/PLAN.md (M15).
 */
import type { IconName } from '../components'

export interface NavItem {
  to: string
  /** Key under `shell.nav` in en.json. */
  label: 'home' | 'pay' | 'loans' | 'statement' | 'more' | 'approvals' | 'close' | 'members' | 'reconciliation' |
    'shareout' | 'setup' | 'dashboard' | 'rulebook' | 'exits' | 'receipts' | 'record'
  icon: IconName
  /** Active only on this exact path (Home), not on everything under it. */
  end?: boolean
}

export const MEMBER_NAV: readonly NavItem[] = [
  { to: '/app/home', label: 'home', icon: 'home' },
  { to: '/app/pay', label: 'pay', icon: 'payments' },
  { to: '/app/loans', label: 'loans', icon: 'request_quote' },
  { to: '/app/statement', label: 'statement', icon: 'receipt_long' },
  { to: '/app/more', label: 'more', icon: 'more_horiz' },
]

export const OFFICER_NAV: readonly NavItem[] = [
  { to: '/app/officer', label: 'home', icon: 'dashboard', end: true },
  { to: '/app/officer/approvals', label: 'approvals', icon: 'pending_actions' },
  { to: '/app/officer/close', label: 'close', icon: 'fact_check' },
  { to: '/app/officer/members', label: 'members', icon: 'groups' },
  { to: '/app/more', label: 'more', icon: 'more_horiz' },
]

/** Officer tools beyond the five: in More on phones, in the side navigation on desktops. */
export const OFFICER_TOOLS: readonly NavItem[] = [
  { to: '/app/officer/receipts', label: 'receipts', icon: 'compare_arrows' },
  { to: '/app/officer/entries/new', label: 'record', icon: 'edit_note' },
  { to: '/app/officer/dashboard', label: 'dashboard', icon: 'monitoring' },
  { to: '/app/officer/rulebook', label: 'rulebook', icon: 'gavel' },
  { to: '/app/officer/exits', label: 'exits', icon: 'rule' },
]

/** The web console (O09, O11, O13): built for 1024 px and wider. */
export const CONSOLE_NAV: readonly NavItem[] = [
  { to: '/app/console/reconciliation', label: 'reconciliation', icon: 'swap_horiz' },
  { to: '/app/console/shareout', label: 'shareout', icon: 'celebration' },
  { to: '/app/console/setup', label: 'setup', icon: 'table_view' },
]
